'use client'

import { useLocale } from '@/components/LocaleProvider'
import type { ReactNode } from 'react'

const linkClass =
  'underline hover:no-underline focus-visible:outline-2 focus-visible:outline-black dark:focus-visible:outline-white focus-visible:outline-offset-2 rounded'

export default function About() {
  const { t } = useLocale()
  const opensNew = t('common.opensInNewWindow')

  const richComponents: Record<string, (chunks: ReactNode) => ReactNode> = {
    strong: (chunks) => <strong>{chunks}</strong>,
    citrii: (chunks) => (
      <a
        href="https://citrii.com"
        className={linkClass}
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>{chunks}</strong>
        <span className="sr-only"> ({opensNew})</span>
      </a>
    ),
    turfsport: (chunks) => <strong>{chunks}</strong>,
    pam: (chunks) => (
      <a
        href="https://pamgolding.co.za"
        className={linkClass}
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>{chunks}</strong>
        <span className="sr-only"> ({opensNew})</span>
      </a>
    ),
    art: (chunks) => (
      <a
        href="https://www.damenoosthuizen.co.za"
        className={linkClass}
        target="_blank"
        rel="noopener noreferrer"
      >
        {chunks}
        <span className="sr-only"> ({opensNew})</span>
      </a>
    ),
    cursor: (chunks) => (
      <a
        href="https://cursor.sh"
        className={linkClass}
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>{chunks}</strong>
        <span className="sr-only"> ({opensNew})</span>
      </a>
    ),
    lovable: (chunks) => (
      <a
        href="https://lovable.so"
        className={linkClass}
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>{chunks}</strong>
        <span className="sr-only"> ({opensNew})</span>
      </a>
    ),
    nano: (chunks) => (
      <a
        href="https://aistudio.google.com/models/gemini-2-5-flash-image"
        className={linkClass}
        target="_blank"
        rel="noopener noreferrer"
      >
        <strong>{chunks}</strong>
        <span className="sr-only"> ({opensNew})</span>
      </a>
    ),
  }

  return (
    <section
      id="about"
      className="scroll-mt-12 pt-6 lg:pt-24 pb-14 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-[3em]"
    >
      <h2 className="sr-only">{t('sections.about')}</h2>
      <div className="space-y-4 text-[15px] leading-relaxed text-foreground/80">
        <p>{t.rich('about.p1', richComponents)}</p>
        <p>{t.rich('about.p2', richComponents)}</p>
        <p>{t.rich('about.p3', richComponents)}</p>
        <p>{t.rich('about.p4', richComponents)}</p>
        <p>{t.rich('about.p5', richComponents)}</p>
        <p className="text-[11px] italic text-foreground/70 mt-6">
          {t('about.footnote')}
        </p>
      </div>
    </section>
  )
}
